'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = loadKruxScript;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Async loader of krux tag on client
 * @param {function} resolve callback function
 * @param {function} reject callback function
 */
var doloadGPTScript = function doloadGPTScript(resolve, reject) {
  /* eslint-disable */
  window.Krux = window.Krux || function () {};
  /* eslint-enable */
  window.Krux.q = window.Krux.q || [];

  /* eslint-disable
  window.Krux||((Krux=function()
    {Krux.q.push(arguments)}
  ).q=[]);
   /* eslint-enable */

  var scriptTag = document.createElement('script');
  scriptTag.src = document.location.protocol + '//cdn.krxd.net/controltag?confid=qixn3cws6';
  scriptTag.async = true;
  scriptTag.type = 'text/javascript';
  scriptTag.onerror = function scriptTagOnError(errs) {
    reject(errs);
  };
  scriptTag.onload = function scriptTagOnLoad() {
    resolve(window.Krux);
  };
  document.getElementsByTagName('head')[0].appendChild(scriptTag);

  /**
   * User data retriver
   * @param {string} n key
   * @returns {string} value
   */
  function retrieve(n) {
    var m = '';
    var k = 'kxuniv_' + n;
    if (window.localStorage) {
      return window.localStorage[k] || '';
    } else if (navigator.cookieEnabled) {
      m = document.cookie.match(k + ' = ([ ^ ;] * )');
      return m && unescape(m[1]) || '';
    }
    return '';
  }
  /* eslint-disable */
  window.Krux.user = retrieve('user');
  window.Krux.segments = retrieve('segs') && retrieve('segs').split(', ') || [];
  /* eslint-enable */
};

/**
 * Async loader of gpt tag on client
 * @returns {Object} promise
 */
function loadKruxScript() {
  return new _promise2.default(function (resolve, reject) {
    doloadGPTScript(resolve, reject);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/ads/vendors/kruxLoader.js
// module id = 126
// module chunks = 35783957827783 71851226274881